var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navigator-item",on:{"click":function($event){return _vm.scroll(_vm.to)}}},[_c('span',{staticClass:"navigator-item-circle"}),_c('span',{staticClass:"navigator-item-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }